import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { OfflineLicenseColumnCaptions } from './tableColumnCaptions';

const OfflineLicenseHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: OfflineLicenseColumnCaptions.key,
    value: objectData ? objectData.key : '',
  }, {
    title: OfflineLicenseColumnCaptions.client.fullName,
    value: objectData
      ? objectData.client
        ? objectData.client.fullName : ''
      : ''
  }];

  return <HistoryTableHeader editedFields={editedFields} captions={OfflineLicenseColumnCaptions} objectData={objectData} title={title}/>
};

export default OfflineLicenseHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/offlineLicenseHistoryTableHeader.js